// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","691":"component---src-pages-index-tsx","713":"component---src-templates-using-dsg-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"9a44b0c96edc28263ac1","691":"f215365ec2b206d508ad","713":"0709052279dbb01aac55","883":"9e31da31a61057a67d18"}[chunkId] + ".js";
};